import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import InvitePage from "@/pages/InvitePage";
import DashboardPage from "@/pages/DashboardPage";
import OrdersByProductPage from "@/pages/OrdersByProductPage";
import ProductsPage from "@/pages/ProductsPage";
import UsersPage from "@/pages/UsersPage";
import ReconciliationPage from "@/pages/ReconciliationPage";
import SupplierOrdersPage from "@/pages/SupplierOrdersPage";
import SupplierTrackingPage from "@/pages/SupplierTrackingPage";
import ReportsPage from "@/pages/ReportsPage";
import FinancePage from "@/pages/FinancePage";
import MalKabulPage from "@/pages/MalKabulPage";
import SettingsPage from "@/pages/SettingsPage";
import ManualOrdersPage from "@/pages/ManualOrdersPage";
import ApiPage from "@/pages/ApiPage";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="flex h-screen items-center justify-center bg-[#F7F7F6]" data-testid="auth-loading">
        <div className="h-6 w-6 animate-spin rounded-full border-2 border-[#1C4E35] border-t-transparent" />
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/kayit" element={<RegisterPage />} />
            <Route path="/sifre-sifirla" element={<ResetPasswordPage />} />
            <Route path="/davet" element={<InvitePage />} />
            <Route
              path="/"
              element={
                <Protected>
                  <Layout />
                </Protected>
              }
            >
              <Route index element={<DashboardPage />} />
              <Route path="siparisler" element={<SupplierTrackingPage />} />
            <Route path="rapor" element={<ReportsPage />} />
            <Route path="finans" element={<FinancePage />} />
            <Route path="mal-kabul" element={<MalKabulPage />} />
            <Route path="ayarlar" element={<SettingsPage />} />
            <Route path="manuel" element={<ManualOrdersPage />} />
            <Route path="api" element={<ApiPage />} />
              <Route path="urun-bazinda" element={<OrdersByProductPage />} />
              <Route path="katalog" element={<ProductsPage />} />
              <Route path="uyum-raporu" element={<ReconciliationPage />} />
              <Route path="tedarik-siparisleri" element={<SupplierOrdersPage />} />
              <Route path="kullanicilar" element={<UsersPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
